/*
 * @Author: huangyf huangyf@efly.cc
 * @Date: 2022-01-19 18:00:27
 * @LastEditors: huangyf huangyf@efly.cc
 * @LastEditTime: 2024-08-09 14:07:42
 * @FilePath: \agent\manage\main\src\main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
// @ts-ignore
import App from './App.vue';
import router from './router';
import store from './store';
import VueRouter from 'vue-router'
// @ts-ignore
import efly from 'efly-ui-test';
import "@/assets/font/iconfont.css";

import {registerMicroApps, start, setDefaultMountApp} from 'qiankun';
import {MicroApps} from './micro-app';
import 'nprogress/nprogress.css';
import  commonComponents  from '@/../../common/index';
import publicAgent from "public-agent"
// import  commonComponents  from 'common';

Vue.config.productionTip = false;
import authority from "@/../../common/src/assets/authority/authority";
const loadingImg = require("@/../../common/src/assets/image/loading.gif");

authority.init(Vue)
authority.getAuthority('superAdmin')

// commonComponents.install(Vue)
efly.install(Vue);
publicAgent.install(Vue)
// @ts-ignore
window['$platform'] = 'ecp'
Vue.prototype.$window = window;
Vue.prototype.$loadingImg = loadingImg;
// 组件总的样式
import '@/assets/sass/index.scss';


const instance = new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')

// 定义loader方法，loading改变时，将变量赋值给App.vue的data中的isLoading
function loader(loading: any) {
    if (instance && instance.$children) {
        // instance.$children[0] 是App.vue，此时直接改动App.vue的isLoading
        // instance.$children[0]['isLoading'] = loading
    }
}

// 给子应用配置加上loader方法
// const apps = MicroApps.routes.map(item => {
//   return {
//     ...item,
//     loader
//   }
// })
registerMicroApps(MicroApps)
// setDefaultMountApp('/resource')

start()

//------------------------

// new Vue({
//   router,
//   store,
//   render: (h) => h(App),
// }).$mount('#app');


